import { render, staticRenderFns } from "./ShareProject.vue?vue&type=template&id=0311ae00&scoped=true&"
import script from "./ShareProject.vue?vue&type=script&lang=js&"
export * from "./ShareProject.vue?vue&type=script&lang=js&"
import style0 from "./ShareProject.vue?vue&type=style&index=0&id=0311ae00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0311ae00",
  null
  
)

export default component.exports